module.exports = __webpack_public_path__ + "img/oota_s.6201e23b.png";